export const chartFontFamily = '\'微软雅黑\', \'Helvetica Neue\', Georgia, Menlo';

export const LoginTypeCookieKey = 'antibot-login-type';